/**
 * Format helpers — réutilisés par les modules V2 (admin + manager).
 */

/** Formate un nombre avec K/M suffix. */
export const fmtNum = (n) => {
  if (n == null || isNaN(n)) return '—';
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return (n / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (abs >= 1_000)     return (n / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
  return Math.round(n).toLocaleString();
};

/** Format USD : `$1,234` (no decimal sauf demandé). */
export const fmtUsd = (n, opts = {}) => {
  if (n == null || isNaN(n)) return '—';
  const decimals = opts.decimals ?? 0;
  return '$' + n.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

/** Format pourcentage `12.3%`. */
export const fmtPct = (n, decimals = 1) => {
  if (n == null || isNaN(n)) return '—';
  return n.toFixed(decimals) + '%';
};

/** Convertit des secondes en `Xh Ym`. */
export const fmtHM = (seconds) => {
  if (seconds == null || isNaN(seconds)) return '—';
  const total = Math.max(0, Math.round(seconds));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
};

/** Convertit des secondes en heures (1 décimale). */
export const secondsToHours = (seconds) => {
  if (seconds == null || isNaN(seconds)) return 0;
  return seconds / 3600;
};

/** Date helpers : retourne la plage [start, end] en YYYY-MM-DD pour une période. */
export const periodRange = (period, refDate = new Date()) => {
  const today = new Date(refDate);
  today.setUTCHours(0, 0, 0, 0);
  const fmt = (d) => d.toISOString().slice(0, 10);

  switch (period) {
    case 'today': {
      return { start: fmt(today), end: fmt(today) };
    }
    case 'yesterday': {
      const y = new Date(today);
      y.setUTCDate(today.getUTCDate() - 1);
      return { start: fmt(y), end: fmt(y) };
    }
    case 'week': {
      const start = new Date(today);
      start.setUTCDate(today.getUTCDate() - 6);
      return { start: fmt(start), end: fmt(today) };
    }
    case 'month':
    default: {
      const start = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 1));
      return { start: fmt(start), end: fmt(today) };
    }
  }
};
